import React from "react";
import "./index.css";

export default function CommonPagination({
  currentPage,
  totalPages,
  onPageChange,
}) {

if (totalPages === 0) return null;

  console.log(currentPage, totalPages);
  

  const handleClick = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  // 🔥 Smart pagination logic
  const getPages = () => {
    const pages = [];
    const range = 1;

    pages.push(1);

    if (currentPage > range + 2) {
      pages.push("...");
    }

    const start = Math.max(2, currentPage - range);
    const end = Math.min(totalPages - 1, currentPage + range);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - (range + 1)) {
      pages.push("...");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="pagination-container">
      {/* Prev */}
      <button
        className="page-btn"
        onClick={() => handleClick(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &laquo;
      </button>

      {/* Pages */}
      {getPages().map((page, index) =>
        page === "..." ? (
          <span key={index} className="dots">
            ...
          </span>
        ) : (
          <button
            key={index}
            className={`page-btn ${currentPage === page ? "active" : ""}`}
            onClick={() => handleClick(page)}
          >
            {page}
          </button>
        )
      )}

      {/* Next */}
      <button
        className="page-btn"
        onClick={() => handleClick(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
       &raquo;
      </button>
    </div>
  );
}